import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FuelSelectorPageRoutingModule } from './fuel-selector-routing.module';

import { FuelSelectorPage } from './fuel-selector.page';
import { ComponentsModule } from 'src/app/components/components.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FuelSelectorPageRoutingModule,
    ComponentsModule,
  ],
  declarations: [FuelSelectorPage],
})
export class FuelSelectorPageModule {}
